import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { Col, Row } from 'react-bootstrap'
import MoviesItemSkeletion from '../Home/moviesItemSkeletion';
const detailmovieSkeleton = () => {
    return (
        <SkeletonTheme color="#2020201c" highlightColor="#93939385">
            <Row>
                <Col xs={12} md={4}>
                    <div className="bg-system rounded p-4 mb-2 pt-5 sticky-md-top sticky-lg-top sticky-xl-top">
                        <div className="d-flex justify-content-center">
                            <Skeleton width={`250px`} height={`400px`} />
                        </div>
                        <div className="p-4 text-center">
                            <h1 className="mb-3 text-warning"><Skeleton width={350} /></h1>
                            <div className="mb-1">
                                <h5><Skeleton width={150} /></h5>
                                <h6><Skeleton width={200} /></h6>
                            </div>
                            <div className="mb-1">
                                <Skeleton width={150} />
                            </div>
                            <h6><Skeleton width={150} /></h6>
                            <h4 className="movie_info"><Skeleton width={100} /></h4>
                            <div className="mt-3">
                                <Skeleton className="w-50 text-white btn-lg fw-bol" />
                                <div>
                                    <Skeleton className="btn mt-3" width={100} />
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col xs={12} md={8} className="px-md-0">
                    <div className="bg-system rounded p-4">
                        <div className="d-md-flex align-items-center justify-content-between my-4 pb-1 w-100">
                            <h4 className="font-size-24 font-weight-medium m-0 text-white"><Skeleton width={100} /></h4>
                        </div>
                        <p><Skeleton count={3} /></p>
                    </div>

                    <div className="bg-system rounded p-4 my-3 container-card">
                        <h4><Skeleton /></h4>
                        <Row className="container-card">
                            <Col xs={4} md={4}>
                                <MoviesItemSkeletion />
                            </Col>
                            <Col xs={4} md={4}>
                                <MoviesItemSkeletion />
                            </Col>
                            <Col xs={4} md={4}>
                                <MoviesItemSkeletion />
                            </Col>
                        </Row>
                    </div>

                </Col>
            </Row>
            {/* <Row className="row mb-5">
                    <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xxl-3">
                        <Skeleton width={`100%`} height={`450px`} />
                    </div>
                    <Col xs={12} md={5}>
                        <div className="p-4 ">
                            <h1 className="mb-3 text-warning"><Skeleton width={350} /></h1>
                            <div className="mb-1">
                                <h5><Skeleton width={150} /></h5>
                                <h6><Skeleton width={200} /></h6>
                            </div>
                            <div className="mb-1">
                                <Skeleton width={150} />
                            </div>
                            <h6><Skeleton width={150} /></h6>
                            <h4 className="movie_info"><Skeleton width={100} /></h4>
                            <div className="mt-3">
                                <Skeleton className="w-50 text-white btn-lg fw-bol" />
                                <div>
                                    <Skeleton className="btn mt-3" width={100} />
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={4}>
                        <h4><Skeleton /></h4>
                        <Row className="container-card">
                            <Col xs={6} md={6}>
                                <MoviesItemSkeletion />
                            </Col>
                            <Col xs={6} md={6}>
                                <MoviesItemSkeletion />
                            </Col>
                        </Row>
                    </Col>
                    <div className="col-12 mt-5 text-white-50">
                        <div className="d-md-flex align-items-center justify-content-between my-4 pb-1 w-100">
                            <h4 className="font-size-24 font-weight-medium m-0 text-white"><Skeleton width={100} /></h4>
                        </div>
                        <p><Skeleton count={3} /></p>
                    </div>
                </Row> */}
        </SkeletonTheme>
    )
}

export default detailmovieSkeleton